import { render, staticRenderFns } from "./AddEditDashboardModal.vue?vue&type=template&id=76a309f7&"
import script from "./AddEditDashboardModal.vue?vue&type=script&lang=js&"
export * from "./AddEditDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports